import NGIcon from '@NGComponents/NGIcon';
import { EIcon } from '@NGComponents/NGIcon/NGIcon.enum';
import AccountTooltip from '@components/tooltips/AccountTooltip';
import useLogin from '@store/userStore/hooks/useLogin';
import Image from 'next/image';
import { FC, Fragment, useState } from 'react';
import useAvatarFaceAssets from 'src/apis/queries/useAvatarFaceAssets';
import useIsLoggedIn from 'src/apis/queries/useIsLoggedIn';
import useUserPersonalData from 'src/apis/queries/useUserPersonalData';
import useResponsive from 'src/hooks/contexts/useResponsive';
import { EAvatarItemType, EAvatarType, ESize, ETextColor } from 'src/styles/theme/utils/enums';
import { ImageEx, StyledAvatarFace, StyledImageContainer, StyledNavbarAvatar } from './NavbarAvatar.styles';

const NavbarAvatar: FC = () => {
	const [tooltipVisible, setTooltipVisible] = useState(false);

	const { isLoggedIn } = useIsLoggedIn();
	const { login } = useLogin();
	const avatarFaceAssets = useAvatarFaceAssets();
	const { avatarType } = useUserPersonalData();
	const { isSmallerThanMd } = useResponsive();

	return (
		<AccountTooltip
			isDisabled={isSmallerThanMd}
			isVisible={tooltipVisible}
			openAction={() => setTooltipVisible(true)}
			closeAction={() => setTooltipVisible(false)}
		>
			<StyledNavbarAvatar
				data-cy='login-tooltip'
				onClick={isSmallerThanMd && !isLoggedIn ? login : undefined}
				isBackgroundHidden={!isLoggedIn}
				onMouseEnter={() => setTooltipVisible(true)}
			>
				{isLoggedIn && avatarFaceAssets?.length ? (
					<StyledAvatarFace>
						{avatarFaceAssets.map((item) => (
							<Fragment key={item.id}>
								{item.type === EAvatarItemType.beard && avatarType === EAvatarType.female ? null : (
									<>
										{!item.displayedAssets?.srcPreview?.small?.url ? null : (
											<ImageEx
												layer={item.layer || 100}
												quality={100}
												src={item.displayedAssets.srcPreview.small.url}
												alt='avatar face'
												layout='fill'
												objectFit='contain'
											/>
										)}

										{!item.displayedAssets?.srcPreviewBack?.small?.url ? null : (
											<ImageEx
												layer={item.layer2 || 100}
												quality={100}
												src={item.displayedAssets.srcPreview.small.url}
												alt='avatar face'
												layout='fill'
												objectFit='contain'
											/>
										)}
									</>
								)}
							</Fragment>
						))}
					</StyledAvatarFace>
				) : !isSmallerThanMd ? (
					<NGIcon type={EIcon.login} size={ESize.m} color={ETextColor.gold} marginTop={'-6px'} marginLeft={'-2px'} />
				) : (
					<StyledImageContainer>
						<Image src='/assets/ng-icon.svg' alt='avatar' draggable={false} width='35' height='50' />
					</StyledImageContainer>
				)}
			</StyledNavbarAvatar>
		</AccountTooltip>
	);
};

export { NavbarAvatar };
